import { useState, useEffect } from 'react';

const AnimatedIcon = ({ 
  icon: Icon, 
  size = 24, 
  color = 'text-pink-500', 
  animation = 'bounce',
  delay = 0,
  duration = '2s',
  className = ''
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, delay);

    return () => clearTimeout(timer);
  }, [delay]);

  const getAnimationClass = () => {
    switch (animation) {
      case 'bounce':
        return 'animate-bounce';
      case 'pulse':
        return 'animate-pulse';
      case 'spin':
        return 'animate-spin';
      case 'ping':
        return 'animate-ping';
      case 'float':
        return 'animate-float';
      case 'glow':
        return 'animate-glow';
      case 'shake':
        return 'animate-shake';
      case 'rotate':
        return 'animate-rotate-y';
      case 'scale':
        return 'animate-scale-pulse';
      default:
        return '';
    }
  };

  return (
    <div 
      className={`inline-block transition-all duration-500 ${
        isVisible ? 'opacity-100 transform translate-y-0' : 'opacity-0 transform translate-y-4'
      } ${className}`}
      style={{ 
        animationDelay: `${delay}ms`,
        animationDuration: duration
      }}
    >
      <Icon 
        size={size} 
        className={`${color} ${getAnimationClass()} hover:scale-110 transition-transform cursor-pointer`}
      />
    </div>
  );
};

export default AnimatedIcon;